// Importações
import service from './';

/**
 * Retorna uma lista dos locais de estacionamento
 * @return {Array<Object>}
 */
export const buscar = async () => {
  try {
    const result = await service.getAll('estacionamentos', {}, '/');
    return result;
  } catch (error) {
    throw error;
  }
};

const estacionamentoService = {
  buscar,
};

export default estacionamentoService;
